// Used in tiles.component.ts, export-course-grades.component.ts, fg-teacher-class-fixer.component.ts, lesson-view.component.ts, composite-assignment.component.ts, page-header.component.ts

import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable()
export class FormatDateTimeHelper {
    constructor() {}

    formatDate = function (date: string | number | undefined) {
        if (!date) {
            return "N/A";
        }
        return moment(date).format("MMM DD, YYYY");
    };

    formatTime = function (date: string | number | undefined) {
        if (!date) {
            return null;
        }
        return moment(date).format("hh:mm A");
    };

    formatDateAndTime(date: string | number | undefined) {
        if (!date) {
            return "N/A";
        }
        return this.formatDate(date) + " at " + this.formatTime(date);
    }
}
